const state = () => ({
  open: false
})

const getters = {
  isPanelOpen: (state) => state.open
}

const mutations = {
  closePanel (state) {
    state.open = false
  },
  togglePanel (state) {
    state.open = !state.open
  }
}

const actions = {
  closePanel ({ commit }) {
    commit('closePanel')
  },
  togglePanel ({ commit }) {
    commit('togglePanel')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
